import Toastify from 'toastify-js'

export default function(options) {
    let container = document.createElement('div')
    container.className = 'mr-3'
    let text = document.createElement('div')
    text.style.whiteSpace = 'pre-line'

    if (options.escapeMarkup === false) {
        text.innerHTML = options.text
    } else {
        text.textContent = options.text
    }

    if (options.title) {
        let title = document.createElement('div')
        title.textContent = options.title

        container.append(title)
    }

    container.append(text)

    if (options.buttons) {
        let divButtons = document.createElement('div')
        divButtons.className = 'mt-2'

        options.buttons.forEach(btn => {
            let button = document.createElement('button')
            button.className = 'btn btn-rounded waves-light waves-effect mr-2 ' + btn.class
            button.textContent = btn.text
            button.addEventListener('click', btn.onClick)

            divButtons.append(button)
        })

        container.append(divButtons)
    }

    return Toastify({
        node: container,
        gravity: "bottom", // `top` or `bottom`
        position: "center", // `left`, `center` or `right`
        close: true,
        duration: 5000,
        className: 'd-flex',
        stopOnFocus: true, // Prevents dismissing of toast on hover
        style: { background: 'linear-gradient(135deg, #8E2DE2, #4A00E0)' },
        ...options,
    })
}
